export const PUBLIC_ROUTE = {
  LANDING: "/",
  SIGN_IN: "/signin",
  FORGET_PASSWORD: "/forgotpassword",
  RESET_PASSWORD: "/resetpassword",
  PAGE_404: "/404",
  PAGE_500: "/500",
  IT_HELPDESK_REQUEST: "/it/helpdesk/request",
};

export const PROTECTED_ROUTE = {
  DASHBOARD: "/dashboard",
  SLEEP_DASHBOARD: "/sleep/dashboard",
  DME_DASHBOARD: "/dme/dashboard",
  IT_DASHBOARD: "/it/dashboard",
  ADMIN_DASHBOARD: "/admin/dashboard",
  STAFFING_DASHBOARD: "/staffing/dashboard",
  NO_ACCESS: "/no-access",
};

export const DASHBOARD_ROUTES = {
  RESTORE: "/dashboard",
  SLEEP: "/sleep/dashboard",
  DME: "/dme/dashboard",
  IT: "/it/dashboard",
  ADMIN: "/admin/dashboard",
  STAFFING: "/staffing/dashboard",
};